export const LocalStorageService = {
    saveItem<T>(key: string, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    },

    getItem<T>(key: string): T | null {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) as T : null;
    },

    removeItem(key: string): void {
        localStorage.removeItem(key);
    },

    clearAll(): void {
        localStorage.clear();
    },

    clearBidKeys(): void {
      const keys = [
          'listing_pending_bids_ALL',
          'listing_pending_bids_SALE',
          'listing_pending_bids_OFFER',

          'bid_pending_bids_ALL',
          'bid_pending_bids_SALE',
          'bid_pending_bids_OFFER',
      ];
        keys.forEach(key => {
            localStorage.removeItem(key);
        });
    },

    clearOrderKeys(): void {
      const keys = [
          'pending_message_count'
      ];
        keys.forEach(key => {
            localStorage.removeItem(key);
        });
    },

    saveItemWithExpiration<T>(key: string, value: T, expirationInMinutes: number): void {
        const now = new Date();
        const expirationTime = now.getTime() + expirationInMinutes  * 60 * 1000;
        const item = {
            value: value,
            expiration: expirationTime
        };
        localStorage.setItem(key, JSON.stringify(item));
    },

    getItemWithExpiration<T>(key: string): T | null {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiration) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }
};